module.exports = __webpack_public_path__ + "media/images/features/4/feature-4-thumbnail-c59431eb43c7ebf4bfe0321f19792316.png";